import React, { useState, useEffect } from 'react';
import './Reviews.css';
import reviewImage1 from '../../assets/images/review1.jpg';
import reviewImage2 from '../../assets/images/review2.jpg';
import reviewImage3 from '../../assets/images/review3.jpg';
import reviewImage4 from '../../assets/images/review4.jpg';
import reviewImage5 from '../../assets/images/review5.jpg';
import reviewImage6 from '../../assets/images/review6.jpg';

const Reviews = () => {
    const slides = [
        { image: reviewImage1, alt: 'Client Review 1' },
        { image: reviewImage2, alt: 'Client Review 2' },
        { image: reviewImage3, alt: 'Client Review 3' },
        { image: reviewImage4, alt: 'Client Review 4' },
        { image: reviewImage5, alt: 'Client Review 5' },  // ✅ new
        { image: reviewImage6, alt: 'Client Review 6' }   // ✅ new
    ];

    const [currentSlide, setCurrentSlide] = useState(0);

    useEffect(() => {
        const interval = setInterval(() => {
            setCurrentSlide((prev) => (prev + 1) % slides.length);
        }, 7000);

        return () => clearInterval(interval);
    }, [slides.length]);

    return (
        <section id="reviews" className="container">
            <div className="section-header">
                <h2 className="section-title">Client Reviews</h2>
                <p className="section-subtitle">Feedback from clients I've worked with</p>
            </div>

            <div className="review-slider">
                {slides.map((slide, index) => (
                    <div key={index} className={`slide ${index === currentSlide ? 'active' : ''}`}>
                        <img src={slide.image} alt={slide.alt} />
                    </div>
                ))}
            </div>

            <div className="slider-dots">
                {slides.map((_, index) => (
                    <span
                        key={index}
                        className={`dot ${index === currentSlide ? 'active' : ''}`}
                        onClick={() => setCurrentSlide(index)}
                    ></span>
                ))}
            </div>

            <div className="review-btn-container">
                <a
                    href="https://khamsat.com/user/hamzaekhwan/reviews"
                    className="review-btn"
                    target="_blank"
                    rel="noopener noreferrer"
                >
                    View More Reviews
                </a>
            </div>
        </section>
    );
};

export default Reviews;
